module.exports = __webpack_public_path__ + "img/product_40.43d03a4.webp";